// DataCenterPage.js
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import StickyHeader from '../../components/StickyHeader';
import StickyFooter from '../../components/StickyFooter';
import '../../css/Home.css';

function DataCenterPage() {
    const [isSystemParamsOpen, setIsSystemParamsOpen] = useState(true);
    const [isDcParamsOpen, setIsDcParamsOpen] = useState(true);
    const [isAcParamsOpen, setIsAcParamsOpen] = useState(true);

    useEffect(() => {
        // 初始化AOS动画库
        AOS.init({
            duration: 1000,
            once: true,
            offset: 100
        });
    }, []);

    const toggleSystemParams = () => {
        setIsSystemParamsOpen(!isSystemParamsOpen);
    };

    const toggleDcParams = () => {
        setIsDcParamsOpen(!isDcParamsOpen);
    };

    const toggleAcParams = () => {
        setIsAcParamsOpen(!isAcParamsOpen);
    };

    return (
        <div className="home-container">
            <StickyHeader />

            {/* 主要内容区域 */}
            <div className="main-content">
                <div className='stitle'>
                    <img
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                        }}
                        src={`${process.env.PUBLIC_URL}/imgs/lianxi.png`}
                        alt=""
                    />
                    <div className='co-textylx'>
                        用户侧储能解决方案领军专家
                    </div>
                    <div className='co-textsylx'>
                        公司聘请中国科学技术大学顶尖研发团队，建设国内一流的储能研发中心，形成BMS、PCS、EMS、储能系统集成等核心技术的自主研发能力，构建了从储能电站投资和开发、产品开发、设备制造到施工运维的全产业链服务体系。公司累计 获得40余项发明/实用新型专利，先后荣获国家级高新技术企业、安徽省“专精特新”企业、省级绿色工厂等资质认证。
                    </div>


                    <div style={{
                        position: "absolute",
                        bottom: "40px",
                        left: "40px",
                        color: "white",
                        textShadow: "0 2px 10px rgba(0, 0, 0, 0.7)",
                        maxWidth: "60%"
                    }}>
                        <h2 style={{
                            fontSize: "3.5rem",
                            fontWeight: "700",
                            marginBottom: "15px",
                            letterSpacing: "2px",
                            lineHeight: "1.2",
                            margin: "0",
                            padding: "0"
                        }}>

                        </h2>
                        <p style={{
                            fontSize: "1.3rem",
                            lineHeight: "1.6",
                            opacity: "0.95",
                            margin: "0",
                            padding: "0"
                        }}>

                        </p>
                    </div>
                </div>
                <div style={{ minHeight: '800px' }}>
                    {/* 第一个盒子 - 方案介绍 */}
                    <div className='top12 animated-section'>
                        <Container>
                            <div className='box'>
                                <div className='top'>
                                    <div className='noe1' data-aos="fade-down">
                                        <span className='h1'>联 系 我 们</span>
                                        <p>
                                            <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                                        </p>
                                    </div>
                                    <div className='boxnollx'>
                                        <div className='lefsl' data-aos="fade-right">
                                            <h3 className='h3slx'>
                                            安徽合利电气股份有限公司
                                            </h3>
                                            <span className='textnoeslx'>
                                                <p>研发中心地址：安徽省合肥市永和路597号绿城科技园D座2层</p>
                                                <p>电话：0551-65650828</p>
                                                <p>联系人：张女士</p>
                                                {/* <p>传真：0556-6160888</p> */}
                                                <p>E-MAIL：AHZHENGRI@163.com</p>
                                            </span>
                                        </div>
                                        <div className='ritus' data-aos="fade-left" data-aos-delay="200">
                                            <img src={`${process.env.PUBLIC_URL}/imgs/lou.png`} alt="" className="image-hovers" />
                                        </div>


                                    </div>

                                </div>
                            </div>
                        </Container>
                    </div>



                    {/* 第三个盒子 - 产品优势 */}
                    <div className='top2ss advantage-section'>
                        <Container>
                            <div className='box'>
                                <div className='top'>
                                    <div className='noe1' data-aos="fade-down">
                                        <span className='h2s'>发 展 历 程</span>
                                        <p>
                                            <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                                        </p>
                                    </div>
                                    <div className='boxnollic'>
                                        <div className='img-year' data-aos="fade-left" data-aos-delay="200">
                                            {/* <img src={`${process.env.PUBLIC_URL}/imgs/2005.png`} alt="" className="image-hovers" /> */}
                                        </div>
                                        <div className='lefsls' data-aos="fade-right">

                                            <div className='textright'>
                                                <h5 className='h5-text'>2005 创业伊始</h5>
                                                <div className=' box-wai'>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>公司成立</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='textright'>
                                                <h5 className='h5-text'>2021 市场认可</h5>
                                                <div className='box-wai'>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>登录新三板（股票代码 873560）</p>
                                                    </div>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>转入创新层
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className='textright'>
                                                <h5 className='h5-text'>2022 科技兴企</h5>
                                                <div className='box-wai'>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>荣获“国家高新技术企业”认定
                                                        </p>
                                                    </div>
                                                    
                                                </div>

                                            </div>
                                            <div className='textright'>
                                                <h5 className='h5-text'>2023 技术储备</h5>
                                                <div className='box-wai'>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>荣获“专精特新企业”认定</p>
                                                    </div>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>荣获“绿色工厂”认定
                                                                </p>
                                                    </div>
                                                    <div className='text-dian'>
                                                        <div className='dians'></div>
                                                        <p className='zipls'>取得“储能设备远程管控平台”、“控制系统UI交互软件”、“AI参数调优系统等12项发明专利以及23项实用新型专利
                                                        </p>
                                                    </div>
                                                    
                                                </div>

                                            </div>
                                            <div className='textright'>
                                                <h5 className='h5-text'>2023 聚才拓进</h5>
                                                <div className='box-wai'>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>聘请中科大顶尖团队，成立研发中心</p>
                                                    </div>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>发布Enersafe Block 215、Enersafe Block 263模块化储能集成系统</p>
                                                    </div>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>自研Nwa-S储能电站智慧管理平台</p>
                                                    </div>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>开展用户侧储能电站投资、开发业务</p>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className='textright'>
                                                <h5 className='h5-text'>2024 奋楫争先 </h5>
                                                <div className='box-wai'>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>用户侧储能电站项目持续签约落地 </p>
                                                    </div>
                                                    
                                                </div>

                                            </div>
                                            <div className='textright'>
                                                <h5 className='h5-text'>2025 赓续前行</h5>
                                                <div className='box-wai'>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>机柜获取CMA、CANS、ilac-MRA型式检验认证报告</p>
                                                    </div>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>取得虚拟电厂调度软件和智慧能源管控平台软著</p>
                                                    </div>
                                                    <div className='text-dian'>
                                                        <div className='dian'></div>
                                                        <p className='zipl'>自持电站超100MWh+，累计服务客户数超80家</p>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>





                                    </div>




                                </div>
                            </div>
                        </Container>
                    </div>






                </div>

            </div>

            <StickyFooter />
        </div>
    );
}

export default DataCenterPage;